<style scoped>
	#app {
		padding: 20px;
	}
	.header {
		line-height: 60px;
		font-size: 16px;
		font-weight: bold;
		
	}
	.table-box {
		margin-top: 10px;
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
	}
	
	.table-header {
		padding: 15px 20px;
		font-size: 14px;
		font-weight: bold;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	
	.box {
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
		display: flex;
		flex-wrap: wrap;
		padding: 10px 0;
		font-size: 14px;
	}
	.form-item {
		height: 60px;
		width: 380px;
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.form-name {
		width: 120px;
		text-align: right;
	}
	.inp {
		width: 280px;
	}
	.el-button--primary {
		background-color: #1677FF!important;
	}
	.dot {
		color: #52C51A;
		padding: 10px;
	}
	.il {
		display: flex;
		flex-direction: row;
	}
	.t-box {
		border: solid 1px #dcdcdc;
		padding: 0 4px;
		border-radius: 4px;
	}
	.t-box1 {
		border: solid 1px #3da113;
		color: #3da113;
		padding: 0 4px;
		border-radius: 4px;
		background-color: #F7FFFE;
	}
	.t-edit {
		font-size: 14px;
		padding: 0 4px;
		margin-left: 10px;
		cursor: pointer;
	}
	.t-a {
		color: #1677FF;
		text-decoration: underline;
		cursor: pointer;
	}
</style>
<template>
	<div id="app">
		<el-breadcrumb class="nav" separator="/" style="margin-bottom: 13px;">
			<el-breadcrumb-item>商品管理</el-breadcrumb-item>
			<el-breadcrumb-item>商品列表</el-breadcrumb-item>
		</el-breadcrumb>
		
		<div class="box">
			<div class="form-item">
				<div style="width: 180px; margin-left: 20px;">
					<el-button size="medium" type="primary" @click="getData()">刷新</el-button>
				<el-button size="medium" type="danger" @click="addFunc">新增商品</el-button>
				</div>
			</div>
		</div>
		
		<div class="table-box">
			<el-table :data="tableData" border 
				v-loading="loading"
				element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)" >
			    <el-table-column prop="gid" label="序号" align="center" width="100"></el-table-column>
				
				<el-table-column prop="title" label="商品标题" align="center"  width="500">
				</el-table-column>
				<el-table-column prop="price" label="售价" align="center" width="140">
				</el-table-column>
				
				<el-table-column prop="is_top" label="类型" align="center" width="140">
					<template slot-scope="scope">
						<el-button type="primary" v-if="scope.row.types == 1" size="mini">次卡商品</el-button>
						<el-button type="warning" v-if="scope.row.types == 2" size="mini">普通商品</el-button>
					</template>
				</el-table-column>
				
				<el-table-column prop="times" label="次数" align="center" width="140">
				</el-table-column>
				
				<el-table-column prop="homes" label="类型" align="center" width="140">
					<template slot-scope="scope">
						<el-button type="primary" v-if="scope.row.homes == 1" size="mini">首页展示</el-button>
						<el-button type="warning" v-if="scope.row.homes == 2" size="mini">普通展示</el-button>
					</template>
				</el-table-column>
				
				<el-table-column prop="selled" label="已售" align="center" width="140">
				</el-table-column>
				
				
				<el-table-column prop="add_time" label="发布时间" align="center" width="200">
				</el-table-column>
				
				<el-table-column prop="status" label="操作" fixed="right" align="center" width="340">
					<template slot-scope="scope">
						<el-button type="danger" @click="showUrl(scope)" size="mini">商品链接</el-button>
						<el-button type="primary" @click="editFunc(scope)" size="mini">查看编辑</el-button>
						<el-button type="warning" @click="deleteFunc(scope)" size="mini">删除</el-button>
					</template>
				</el-table-column>
				
			  </el-table>
			  
			  <div  style="flex-grow: 1; display: flex; flex-direction: row; justify-content: flex-end; margin: 10px 10px 10px 0;">
			  <el-pagination
			        @size-change="handleSizeChange"
			        @current-change="handleCurrentChange"
			        :current-page="currentPage"
			        :page-sizes="[10, 20, 50, 100]"
			        :page-size="limit"
			        layout="total, sizes, prev, pager, next, jumper"
			        :total="total">
			      </el-pagination>
			  </div>
		</div>
		
		<el-dialog title="新增商品" :visible.sync="dialogVisible" v-if="dialogVisible" width="1000px" :before-close="handleClose">
		  <addGoods></addGoods>
		</el-dialog>
		
		<el-dialog title="编辑商品" :visible.sync="dialogVisible1" v-if="dialogVisible1" width="1000px" :before-close="handleClose">
		  <editGoods :ruleForm="editInfo"></editGoods>
		</el-dialog>
		
	</div> 
</template>

<script>
	import addGoods from './addGoods.vue';
	import editGoods from './editGoods.vue';
	
	export default {
		components:{
			addGoods, editGoods
		},
		computed:{
		},
		data(){
			return {
				dialogVisible1:false,
				dialogVisible:false,
				loading:false,
				currentPage:1,
				tableData: [],
				total:0,
				limit:10,
				keyword:'',
				editInfo:{}
			}
		},
		created() {
			this.getData();
		},
		methods:{
			showUrl(scope){
				let _url = '/pages/goods/goodsDetail?gid=' + scope.row.gid;
				this.$prompt('可复制到Banner跳转或者公告跳转', '商品链接', {
				          confirmButtonText: '确定',
						  inputValue:_url,
						  showCancelButton:false,
				        }).then(({ value }) => {
				        }).catch(() => {
				        });	
			},
			deleteApi(scope){
				let _this = this;
				_this.loading = true;
				_this.$api.post("/Goods/deleteGoods", {gid:scope.row.gid}).then(res=>{
					_this.loading = false;
					if(res.code == 200){
						_this.tableData.splice(scope.$index, 1);
						_this.$message({ message: '删除成功', type: 'success', });
					}else{
						_this.$message({ message: '删除失败', type: 'warning', });
					}
				}).catch(res=>{
					_this.loading = false;
				});
			},
			deleteFunc(scope){
				let _this = this;
				this.$confirm('是否确认删除此商品?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					_this.deleteApi(scope);
				}).catch(() => {      
				});
			},
			editFunc(scope){
				this.editInfo = scope.row;
				this.dialogVisible1 = true;
			},
			addFunc(){
				this.dialogVisible = true;
			},
			handleClose(){
				this.dialogVisible = false;
				this.dialogVisible1 = false;
			},
			getData(){
				let that = this;
				that.loading = true;
				that.$api.post("/Goods/getGoodsList", {page:this.currentPage, limit:this.limit, keyword:this.keyword}).then(res=>{
					that.loading = false;
					that.tableData = res.data.list;
					that.total = res.data.total;
				}).catch(res=>{
					that.loading = false;
				});
			},
			handleSizeChange(e){
				this.limit = e;
				this.getData();
			},
			handleCurrentChange(e){
				this.currentPage = e;
				this.getData();
			}
		}
	}
</script>

